import React from 'react';
import { IProps } from './types';
import SliderBoundless from 'components/SliderBoundless';
import _ from 'lodash';

const InnerPageBAds: React.FC<IProps> = (props) => {
  /**
   * @description 建立圖片樣式
  */
  const handleCreateImgs = (imgUrls: string[]) => {
    const childs = _.map(imgUrls, (url: string, index: number) => {
      return (
        <SliderBoundless.Item key={index}>
          <span>
            <img src={url} alt="" className="member-only__inner-page-b-ads-banner-pc" />
            <img src={url} alt="" className="member-only__inner-page-b-ads-banner-mobile" />
          </span>
        </SliderBoundless.Item>
      );
    });

    return (
      <SliderBoundless name="inner-page-b-ads-slider">
        {childs}
      </SliderBoundless>
    );
  };
  return props.imgUrls && props.imgUrls.length > 0 ? (
    <div className="member-only__inner-page-b-ads">
      {handleCreateImgs(props.imgUrls)}
    </div>
  ) : null;
};

export default InnerPageBAds;
